<template>
<div id="secure">

    <section class="main-content columns is-fullheight">
        <SideMenu />
        
        <div class="container column is-9">
            <div class="section">
                <loading :active.sync="isLoading" 
                    :can-cancel="false" 
                    :is-full-page="true">
                </loading>
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card">
                    <div class="card-header"><p class="card-header-title">Settings</p></div>
                    <div class="card-content">
                        <div class="columns" style="padding: 10px;">
                            <div class="column">
                                <div class="field">
                                    <div class="control">
                                        <input class="input is-success" type="text" placeholder="School Name" v-model="name">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="text" placeholder="School Address" v-model="address">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <b-checkbox v-model="isNewPassword" v-on:change="isEnableNewPassword()">
                                            Change Password
                                        </b-checkbox>
                                    </div>
                                    <div class="control">
                                        <input class="input" type="password" placeholder="Password (enter new password to change)" v-model="password1" :disabled="!isNewPassword">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="password" placeholder="New password, again" v-model="password2" :disabled="!isNewPassword">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <b-checkbox v-model="isNewLogo" v-on:change="isEnableNewLogo()">
                                            Upload new logo
                                        </b-checkbox>
                                    </div>
                                    <div class="label">School Logo</div>
                                    <div class="control">
                                        <input type="file" id="file" ref="file" accept="image/*" v-on:change="handleFileUpload()" :disabled="!isNewLogo" />
                                        <img v-bind:src="imagePreview" v-show="showPreview"/>
                                    </div>
                                </div>
                                
                                <div class="field">
                                    <label class="label">&nbsp;</label>
                                        <div class='ui two buttons'>
                                            <button class='button is-primary' v-on:click="update()">Update</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><br/>
                

            </div>
        </div>
    </section>
</div>

</template>

<script>
import SideMenu from './SideMenu'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "settings",
    components: {
        SideMenu,
        Loading
    },
    data() {
        return {
            isLoading: false,
            result: "",
            file: '',
            showPreview: false,
            imagePreview: '',
            schoolInfo: '',
            email: '',
            name: '',
            address: '',
            password1: '',
            password2: '',
            isNewPassword: false,
            isNewLogo: false,
        };
    },
    beforeMount() {
    },
    created() {
        this.getData()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        isEnableNewPassword(){
            if (isNewPassword){
                this.isNewPassword = true;
            }else{
                this.isNewPassword = false;
            }
        },
        isEnableNewLogo(){
            if (isNewLogo){
                this.isNewLogo = true;
            }else{
                this.isNewLogo = false;
            }
        },   
        handleFileUpload() {
            /*
            Set the local file variable to what the user has selected.
            */
            this.file = this.$refs.file.files[0];

            /*
            Initialize a File Reader object
            */
            let reader = new FileReader();

            /*
            Add an event listener to the reader that when the file
            has been loaded, we flag the show preview as true and set the
            image to be what was read from the reader.
            */
            reader.addEventListener("load", function () {
                this.showPreview = true;
                this.imagePreview = reader.result;
            }.bind(this), false);

            /*
            Check to see if the file is not empty.
            */
            if (this.file) {
                /*
                    Ensure the file is an image file.
                */
                if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
                    /*
                    Fire the readAsDataURL method which will read the file in and
                    upon completion fire a 'load' event which we will listen to and
                    display the image in the preview.
                    */
                    reader.readAsDataURL(this.file);
                    console.log("fileName: " + this.file.name)
                }
            } else {
                alert("Empty file?!")
            }
        },
        getData(){
            let self = this
            this.isLoading = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.post(process.env.MY_URL + '/api/auth/school/info', {
                params: {
                    email: localStorage.getItem('email'),
                }
            })
            .then(response => {
            // JSON responses are automatically parsed.
                self.schoolInfo = response.data
                self.name = self.schoolInfo[0].name
                self.address = self.schoolInfo[0].address
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
            })
        },
        update() {
            console.log("imini 83")
            let self = this
            self.isLoading = true;
            let formData = new FormData();
            if (this.name.length > 0) {

                if (this.isNewLogo){
                    if (this.file.name == null){
                        alert("You chose to upload new logo. Please select the image you want to upload.")
                        self.isLoading = false
                        return false;
                    }
                }

                var isNewLogo = 0;
                if (this.isNewLogo){
                    isNewLogo = 1;
                }
                var isNewPassword = 0;
                var newPassword = "";
                if (this.isNewPassword){
                    if (this.password1.length >= 8){                        
                        if (this.password1 == this.password2){                            
                            isNewPassword = 1;
                            newPassword = this.password1
                        }else{
                            alert("Please make sure you typed in the correct new password in both fields.")
                            self.isLoading = false
                            return false;
                        }
                    }else{
                        alert("Password must be at least 8 characters.")
                        self.isLoading = false
                        return false;
                    }
                }

                formData.append('email', localStorage.getItem('email'));
                formData.append('file', this.file);
                formData.append('name', this.name);
                formData.append('address', this.address);
                formData.append('isNewLogo', isNewLogo);
                formData.append('isNewPassword', isNewPassword);
                formData.append('newPassword', newPassword);

                this.email = localStorage.getItem('email')

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'

                /*
                    Make the request to the POST /single-file URL
                */
                axios.post(process.env.MY_URL + '/api/auth/school/info/update',
                        formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        console.log('SUCCESS!!');
                        console.log(response)
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })                            
                            this.file = ""
                            this.imagePreview = ""
                        }
                        self.isLoading = false
                    })
                    .catch(e => {
                        console.log(e.response)
                        self.isLoading = false
                    });
            } else {
                alert("Please enter the school's name");
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue